// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"652":"98bc9bc1","769":"95b8f6de"}[chunkId] + ".chunk.js";
};